<template>
  <v-menu>
    <template #activator="{ isActive, props }">
      <v-btn
        v-bind="props"
        data-cy="notification-button">
        <v-badge
          v-if="mainStore.unreadNotifications > 0"
          :location="'top right'"
          :offsetX="0"
          :offsetY="2"
          :color="'error'"
          :content="mainStore.unreadNotifications">
          <v-icon
            size="28">mdi-bell</v-icon>
        </v-badge>
        <v-icon v-else
          size="28">mdi-bell</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <v-list-item
      v-for="item in mainStore.notifications"
        data-cy="show-account-view">
            <template v-slot:append>
             <v-icon v-if="!item.read" @click="markRead(item)">mdi-check</v-icon>
             <v-icon v-if="JSON.parse(item.data).link" @click="router.push(JSON.parse(item.data).link)">mdi-open-in-new</v-icon>
           </template>
        <v-list-item-title>
          {{ $t(`notifications.${item.message_code}.title`, { ...notificationParams(item), interpolation: { escapeValue: false } }) }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ $t(`notifications.${item.message_code}.message`, { ...notificationParams(item), interpolation: { escapeValue: false } }) }}
        </v-list-item-subtitle>

      </v-list-item>
      <v-list-item
        v-if="mainStore.notifications.length === 0"
        data-cy="no-notifications">
        <v-list-item-title>
          {{ $t(`notifications.no_notifications.title`) }}
        </v-list-item-title>

      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import axios from "axios";
import { computed, onMounted, ref } from "vue";
import { useMainStore } from "@/stores/mainStore";
import { useRouter } from "vue-router";
import { useTranslation } from "i18next-vue";
import { notification } from "@/types/global";
import { formatModuleSlots } from "@/views/Main/Licence/moduleComposable";

const mainStore = useMainStore();

const router = useRouter();

const { t } = useTranslation();

/**
 * Template params of a notification. The trial notifications carry structured
 * data (module -> slots, ISO date / unix seconds) that is formatted here.
 */
function notificationParams(item: notification) {
  const data = JSON.parse(item.data || "{}");
  const modulesText = (mods: Record<string, number> = {}) => formatModuleSlots(t, mods);

  if (item.message_code === "trial_ending") {
    return {
      ...data,
      modules: modulesText(data.modules),
      date: new Date(data.end_date).toLocaleDateString()
    };
  }
  if (item.message_code === "trial_expired") {
    return {
      ...data,
      modules: modulesText(data.modules),
      removed: data.removed?.length ?? 0
    };
  }
  if (
    item.message_code === "trial_payment_method_required" ||
    item.message_code === "trial_continue_reminder"
  ) {
    return {
      ...data,
      date: new Date(data.trial_end * 1000).toLocaleDateString()
    };
  }
  return data;
}

function markRead(item: notification) {
  item.read = true;
  axios.post(`/api/notification/mark-read/${item.id}`).then(() => {

  });
}

</script>

<style scoped>

</style>
